import React from "react";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { ExamCommitteeStatus } from "utils/constants";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { Button, useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const UpdateStatusDialog = ({ status, id }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const action = status === ExamCommitteeStatus.Active ? "deactivate" : "activate";

  const handleSubmit = async () => {
    await dataProvider.customRequest(specialistRequests.updateExamCommitteeStatus(id, action), null, "PUT");
    notify("Успешно сменихте статуса на изпитната комисия", { type: "success" });
    refresh();
  };
  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={status === ExamCommitteeStatus.Active ? "Смени статуса на Неактивен" : "Смени статуса на Активен"}
      triggerButton={
        <Button
          startIcon={<AutorenewIcon />}
          size="small"
          label={status === ExamCommitteeStatus.Active ? "Деактивирай" : "Активирай"}
          variant="contained"
          sx={{
            bgcolor: status === ExamCommitteeStatus.Active ? "error.main" : "success.light",
            "&:hover": {
              bgcolor: status === ExamCommitteeStatus.Active ? "error.dark" : "success.main",
            },
          }}
        />
      }
      message="Сигурни ли сте, че искате да смените статуса на изпитната комисия?"
    />
  );
};

export default UpdateStatusDialog;
